import { getCookie,  } from './getCookie'
import deserialize from '../deserialize'
import { ClientInfo } from '../types'
import Ipstack from 'apilayer-ipstack'
import { ipStackKey, tokenKey } from '../../global'
const useToken = () => {
    const key =  tokenKey
    const token = getCookie(key)
    const refreshToken = getCookie('refreshToken')
    const _locationId = getCookie('level')
    const _loc = _locationId && deserialize(_locationId)
    const locationId = (_loc && _loc?.locationId!) || ''
    return { token, refreshToken, locationId }
}


export const getClientInfo = async (): Promise<ClientInfo> => {
    const key = ipStackKey
    const clientInfo = localStorage.getItem('clientmetadata')
    let info: ClientInfo = {}
    if (clientInfo) {
        info = deserialize(clientInfo)
        return info
    } else {
        const ipstack = new Ipstack(key);
        return ipstack.requestIP()
    }
}
export default useToken
